import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import contact from "../../../assets/images/contact.png";
import facebook from "../../../assets/images/fb.png";
import instagram from "../../../assets/images/instagram.png";
import { inquirySubmit } from "../../../redux/features/inquiry/inquiryservice";
import { useDispatch, useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import { showToast } from "../../../components/ToastMsg";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { isInquiryLoading, inquiryMessage } = useSelector((state) => state.inquiry.inquiryDetails)

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [errorMessages, setErrorMessages] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSuccess, setSuccess] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const validateFormData = () => {
    const errors = {};
    const trimmedName = formData.name.trim();
    const trimmedEmail = formData.email.trim();
    const trimmedSubject = formData.subject.trim();
    const trimmedMassage = formData.message.trim();

    if(i18n.language === 'en'){
    if (!trimmedName) {
      errors.name = "Name is required.";
    }
    if (!trimmedEmail) {
      errors.email = "Email is required.";
    }
    if (trimmedEmail && !validateEmail(trimmedEmail)) {
      errors.email = 'Please add a valid email.'
    }
    if (!trimmedSubject) {
      errors.subject = "Subject is required.";
    }
    if (!trimmedMassage) {
      errors.message = "Message is required.";
    }
  }
   if(i18n.language === 'si'){
    if (!trimmedName) {
      errors.name = "නම අවශ්‍යයි.";
    }
    if (!trimmedEmail) {
      errors.email = "විද්‍යුත් තැපෑල අවශ්‍යයි.";
    }
    if (trimmedEmail && !validateEmail(trimmedEmail)) {
      errors.email = 'කරුණාකර වලංගු විද්‍යුත් තැපෑලක් එක් කරන්න.'
    }
    if (!trimmedSubject) {
      errors.subject = "මාතෘකාව අවශ්‍යයි.";
    }
    if (!trimmedMassage) {
      errors.message = "පණිවිඩයක් අවශ්‍යයි.";
    }
  }
   if(i18n.language === 'ta'){
    if (!trimmedName) {
      errors.name = "பெயர் தேவை.";
    }
    if (!trimmedEmail) {
      errors.email = "மின்னஞ்சல் தேவை.";
    }
    if (trimmedEmail && !validateEmail(trimmedEmail)) {
      errors.email = 'தயவுசெய்து ஒரு செல்லுபடியாகும் மின்னஞ்சலைச் சேர்க்கவும்.'
    }
    if (!trimmedSubject) {
      errors.subject = "தலைப்பு தேவை.";
    }
    if (!trimmedMassage) {
      errors.message = "செய்தி தேவை.";
    }
  }

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorMessages((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const inquirySubmission = async () => {
    try {
      if (validateFormData()) {
        const trimmedFormData = {
          name: formData.name?.trim(),
          email: formData.email?.trim(),
          subject: formData.subject?.trim(),
          message: formData.message?.trim(),
        };
        const response = await dispatch(inquirySubmit(trimmedFormData)).unwrap();
        if (response.success) {
          showToast('success', response.message)
          setSuccess(true);
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
        }
      }
    } catch (err) {
      showToast('error', err.message)
      setSuccess(false);
    }
  }

  return (
    <div className={styles.bgColor}>
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={`card-section`}>
            <div className={`main-card`}>
              <h1 className={`form-title ${styles.title}`}>{t(`Contact`)}</h1>
              <div className={styles.container}>
                <div className={styles.formContainer}>
                  <form noValidate>
                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <label htmlFor="name" className={`form-label`}>
                          {t(`Name`)}<span className={`required-star`}>*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder={i18n.language === 'si'? `ඔබගේ නම` : i18n.language === 'ta'? `உங்கள் பெயரை உள்ளிடவும்` : `Your name`}
                          className={`${styles.contactInput} ${styles.formInput}`}
                        />
                        {errorMessages.name && (
                          <p className={`text-danger`}>
                            {errorMessages.name}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <label htmlFor="email" className={`form-label`}>
                          {t(`Email`)}<span className={`required-star`}>*</span>
                        </label>
                        <input
                          type="text"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder={i18n.language === 'si'? `ඔබගේ විද්‍යුත් තැපෑල` : i18n.language === 'ta'? `உங்கள் மின்னஞ்சலை உள்ளிடவும்` : `Your email`}
                          className={`${styles.contactInput} ${styles.formInput}`}
                        />
                        {errorMessages.email && (
                          <p className={`text-danger`}>
                            {errorMessages.email}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <label htmlFor="subject" className={`form-label`}>
                          {t(`Subject`)}<span className={`required-star`}>*</span>
                        </label>
                        <input
                          type="text"
                          id="subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleInputChange}
                          placeholder={`${t(`Subject`)}`}
                          className={`${styles.contactInput} ${styles.formInput}`}
                        />
                        {errorMessages.subject && (
                          <p className={`text-danger`}>
                            {errorMessages.subject}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <label htmlFor="message" className={`form-label`}>
                          {t(`Message`)}<span className={`required-star`}>*</span>
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          placeholder={`${t(`Message`)}`}
                          className={`${styles.contactInput} ${styles.formInput} ${styles.textarea}`}
                        />
                        {errorMessages.message && (
                          <p className={`text-danger`}>
                            {errorMessages.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <button className={styles.submitBtn} type="button" onClick={inquirySubmission} disabled={isInquiryLoading}>
                      {isInquiryLoading ? <BeatLoader color="#ffffff" /> : `${t(`Submit`)}`}
                    </button>
                  </form>
                </div>
                <div className={styles.infoSection}>
                  <img
                    src={contact}
                    alt="Customer Support"
                    className={styles.contactImage}
                  />
                  <div className={styles.contactDetails}>
                    <p className={styles.infoTitle}>{t(`Phone`)}</p>
                    <p className={styles.infoDetails}>+94 703 777999</p>
                    <p className={styles.infoTitle}>WhatsApp</p>
                    <p className={styles.infoDetails}>+94 703 777999</p>
                    <p className={styles.infoTitle}>{t(`Email`)}</p>
                    <p className={styles.infoDetailsEmail}>
                      info@mylottery.lk
                    </p>
                    <p className={styles.infoTitle}>{t(`Address`)}</p>
                    <p className={styles.infoDetailsAddress}>
                      {(() => {
                        const t = {
                          si: {
                            street: 'බෙල්ලන්තර පාර',
                            union: 'යුනියන් ප්ලේස්',
                            city: 'දෙහිවල',
                            country: 'ශ්‍රී ලංකාව'
                          },
                          ta: {
                            street: 'பெல்லந்தர சாலை',
                            union: 'யூனியன் பிளேஸ்',
                            city: 'தேஹிவால',
                            country: 'இலங்கை'
                          },
                          en: {
                            street: 'Bellanthara Road',
                            union: 'Union Place',
                            city: 'Dehiwala',
                            country: 'Sri Lanka'
                          }
                        };
                        const lang = t[i18n.language] || t.en;
                        return (
                          <>
                            40/7,
                            <br />
                            {lang.street},
                            <br />
                            {lang.union},
                            <br />
                            {lang.city},
                            <br />
                            {lang.country}.
                          </>
                        );
                      })()}
                    </p>
                  </div>
                  <div className={styles.socialLinks}>
                    <a>
                      <img src={facebook} alt="Facebook" />
                    </a>
                    <a>
                      <img src={instagram} alt="Instagram" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
